import $ from 'jquery';

// Simulates clicking an element with very low level events. This is usually
// helpful when dealing with code like from Google, where they roll all their
// own event handlers.
export const forceClickElement = element => {
  $(document).ready(() => {
    const mouseDown = document.createEvent('MouseEvent');
    const mouseUp = document.createEvent('MouseEvent');
    const args = [
      true, // bubble
      true, // cancelable
      window,
      null,
      0, // coordinates
      0,
      0,
      0,
      false, // modifier keys
      false,
      false,
      false,
      0, // left
      null,
    ];

    mouseDown.initMouseEvent('mousedown', ...args);
    mouseUp.initMouseEvent('mouseup', ...args);

    element.dispatchEvent(mouseDown);
    element.dispatchEvent(mouseUp);
  });
};
